import MatchingTableHeaders from '../constants/MatchingTableHeaders';

export const API_HEADERS = MatchingTableHeaders.map(
  ({ fieldName }) => fieldName,
);

export type APIHeader = (typeof API_HEADERS)[number];

export const MatchType: { [key: string]: string } = Object.freeze({
  MATCHED: 'matched',
  UNMATCHED: 'unmatched',
});

export default {
  MatchType,
  API_HEADERS,
  MatchingTableHeaders,
};
